import AddEntity from "@/components/generics/AddEntity.vue";

import Api from "@/modules/axios";
import { displaySuccess, displayBddError, displayErrorSelectOneMin } from "@/modules/utils";

import MixinModalConfirm from "@/mixins/mixinModalConfirm";

import config from "@/config";

export default {
  name: "mixinBudget",
  components: {
    AddEntity,
  },
  mixins: [MixinModalConfirm],
  emits: [
    /**
     * Déclenché lorsque la modale des budgets est fermée.
     */
    "refresh",
  ],
  props: {
    /**
     * Définit l'année fiscale du budget.
     */
    annee: {
      type: [Number, String],
      required: true,
    },
    /**
     * Définit les infos du budget (totaux).
     */
    infoBudgets: Object,
    /**
     * Définit le numéro du budget.
     */
    budget: {
      type: String,
      required: true,
    },
  },
  computed: {
    actions() {
      const actions = [
        { title: "Ajouter", callback: "add" },
      ];

      actions.push({ title: "Supprimer", callback: "deletePermanent" });

      return actions;
    },
    refTableDebit() {
      if (this.namespace === "Budget1372Debit") {
        return "genericTableDebit1372";
      }
      if (this.namespace === "Budget1380Debit") {
        return "genericTableDebit1380";
      }
      return null;
    },
  },
  watch: {
    annee() {
      if (this.url) {
        this.$store.commit(`${this.namespace}/setUrl`, this.url);
        this.$store.dispatch(`${this.namespace}/fetchData`);
      }
    },
  },
  methods: {
    /**
     * Exécute les actions du tableau du budget.
     * @public
     * @param {String} actionCode Action sélectionnée.
     */
    dispatchAction(actionCode) {
      let checkedRows = null;

      if (actionCode === "deletePermanent") {
        // Définition des lignes cochées
        checkedRows = this.$store.getters[
          `${this.namespace}/rowDisplayed`
        ].filter((row) => row._checkBoxChecked);

        if (checkedRows.length > 0) {
          this.displayModalConfirm(
            () => {
              checkedRows.forEach((row) => {
                this.deleteDebit(row);
              });
              this.$store.commit(`${this.namespace}/setAllChecked`, false);
            },
            null,
            "Supprimer définitivement cette ligne ?",
            "Cliquez sur \"oui\" pour confirmer."
            + " Attention, elle peut être liée à un réglement ou un achat."
            + " Cette action est irréversible.",
          );
        } else {
          displayErrorSelectOneMin("une ligne");
        }
      }

      switch (actionCode) {
        case "add":
          // Définir un budget par défaut à la création d'un budget.
          // Le type attendu du budget est un Number, mais this.budget est un String.
          // Voir méthode fetchOption() dans AddEntity.
          this.$refs.addEntity.displayModal({ budget: parseInt(this.budget, 10) });
          break;

        default:
          break;
      }
    },
    /**
     * Exporte les données d'un budget.
     * @public
     */
    exportSimple() {
      const checkedRows = this.$store.getters[
        `${this.namespace}/rowDisplayed`
      ].filter((row) => row._checkBoxChecked);

      // Le namespace est défini comme suit : "Budget1372Credit"
      const num = this.namespace.slice(6, 10);
      const type = this.namespace.toLowerCase().slice(10);

      window.open(`${config.api.baseUrl}/export/budget/?\
budget=${num}\
&type=${type}\
&annee=${this.annee}\
&lignes=${checkedRows.map((ligne) => ligne.id).join(",")}`,
      "_blank");
    },
    /**
     * Affiche la modale de modification de la ligne d'un budget avec ses détails.
     * @public
     * @param {Object} row Ligne sélectionnée.
     */
    openDetails(row) {
      this.$refs.addEntity.displayModal(row);
    },
    /**
     * Supprime la ligne du débit.
     * @public
     * @param {Object} ligne Ligne sélectionnée.
     */
    deleteDebit(ligne) {
      let num = this.namespace.slice(6, 10);
      num = (num === "1380") ? "2991" : num;

      const type = this.namespace.toLowerCase().slice(10);
      const url = `${type}${type === "credit" ? num : ""}/${ligne.id}/`;

      Api()
        .delete(url)
        .then(() => {
          this.$store.dispatch(`${this.namespace}/fetchData`);
          displaySuccess("Le débit a été définitivement supprimé.");
        })
        .catch(displayBddError);
    },
  },
};
